import { Box } from '@primer/react';
import { Dialog } from '@primer/react/experimental';
import { DividerLine } from '@upright/ui/common/generic/components/primer-custom/divider-line';
import { breakpoints } from '@upright/ui/common/generic/global/breakpoints';
import { uiImpactCategoryByCode } from '../../../../../../../common/model/input/impacts';
import { ModelEntityType } from '../../../../../../../common/model/input/types';
import { friendlyImpactTitle } from '../../../../../../../common/utils';
import { BasisForCalculation } from './basis-for-calculation';
import { ImpactCategoryDefinition } from './impact-category-definition';
import { ImpactCategoryExamples } from './impact-category-examples';
import { MoreInformation } from './more-information';
import { TopicsConsidered } from './topics-considered';

interface Props {
  impactCode?: string;
  type: ModelEntityType;
  onClose: () => void;
  isOpen: boolean;
}

export const ImpactExplanationModal = (props: Props) => {
  if (!props.impactCode || !props.isOpen) {
    return <></>;
  }

  const category = uiImpactCategoryByCode[props.impactCode];
  const { explanations } = category;

  const showDefinition = props.type === ModelEntityType.PRODUCT;

  const closeDialog = () => {
    props.onClose();
  };

  return (
    <Dialog
      title={`${friendlyImpactTitle(props.impactCode)}: What does this impact category mean?`}
      footerButtons={[{ content: 'Close', onClick: closeDialog }]}
      onClose={closeDialog}
      sx={{
        [`@media screen and (max-width: ${breakpoints[0]})`]: {
          position: 'absolute',
          bottom: 0,
          width: '100vw',
          maxWidth: '100vw',
        },
      }}
    >
      {showDefinition && (
        <Box mb={3}>
          <ImpactCategoryDefinition definition={explanations.productViewExplanation} />
          <DividerLine />
        </Box>
      )}
      <TopicsConsidered topicsConsidered={explanations.topicsConsidered} />
      <DividerLine />
      <BasisForCalculation category={category} />
      <DividerLine />
      <ImpactCategoryExamples {...explanations.explanationsAndExamplesByValence} />
      <DividerLine />
      <MoreInformation />
    </Dialog>
  );
};
